// Third party
import { combineEpics } from "redux-observable";

// Project
import messageListRequestedEpic from "./messageListRequestedEpic";
import messageListLoadingStartEpic from "./messageListLoadingStartEpic";
import messageListLoadingErredEpic from "./messageListLoadingErredEpic";

export default combineEpics(messageListRequestedEpic, messageListLoadingStartEpic, messageListLoadingErredEpic);
